import is from '@sindresorhus/is';
import { useEffect, useRef } from 'react';

import { useOptionalCommentsGroupStoreApi } from './comments-group-context';
import type { CommentsGroupMemberRegistration } from './comments-group-member';

const registrationKey = ({ label, memberId, role, subject }: CommentsGroupMemberRegistration): string =>
    [
        memberId,
        label,
        role,
        subject.architectureId,
        subject.subjectId,
        subject.kind,
        subject.language,
        subject.persistence,
        subject.transportVersion,
        subject.canCreateThreads,
    ].join('|');

export const useRegisterCommentsGroupMember = (registration: CommentsGroupMemberRegistration | null): void => {
    const store = useOptionalCommentsGroupStoreApi();
    const registrationRef = useRef(registration);
    registrationRef.current = registration;
    const key = is.null(registration) ? null : registrationKey(registration);
    const memberId = registration?.memberId ?? null;

    useEffect(() => {
        const current = registrationRef.current;
        if (is.null(store) || is.null(key) || is.null(current)) return;
        store.getState().registerMember(current);
    }, [store, key]);

    useEffect(() => {
        if (is.null(store) || is.null(memberId)) return;
        return () => store.getState().unregisterMember(memberId);
    }, [store, memberId]);
};
